<template>
    <console-layout width="100%" max-width="1024">
        <console-title>
            <span v-if="member._id">회원상세</span>
            <span v-else>회원등록</span>
        </console-title>

        <console-body>
            <v-row class="ma-n2">
                <v-col class="pa-2" cols="12" md="8">
                    <v-card>
                        <v-card-title class="subtitle-2 font-weight-bold">기본정보</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-row class="ma-n1">
                                        <v-col class="pa-1" cols="12" md="6">
                                            <v-text-field v-model="member.username" label="아이디" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details />
                                        </v-col>
                                        <v-col class="pa-1" cols="12" md="6">
                                            <v-password-field v-model="member.password" label="비밀번호" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details />
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12">
                                    <v-row class="ma-n1">
                                        <v-col class="pa-1" cols="12" md="6">
                                            <v-text-field v-model="member.name" label="이름" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details />
                                        </v-col>
                                        <v-col class="pa-1" cols="12" md="6"> </v-col>
                                        <v-col class="pa-1" cols="12" md="6">
                                            <v-text-field v-model="member.phone" label="연락처" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details />
                                        </v-col>
                                        <v-col class="pa-1" cols="12" md="6">
                                            <v-text-field v-model="member.email" label="이메일" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details />
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12">
                                    <v-row class="ma-n1">
                                        <v-col class="pa-1" cols="12" md="6">
                                            <v-text-field v-model="member.postcode" label="우편번호" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details readonly @click="$refs.daumPostcode.open()" />
                                        </v-col>
                                        <v-col class="pa-1" cols="12">
                                            <v-row class="ma-n1">
                                                <v-col class="pa-1" cols="12" md="6">
                                                    <v-text-field v-model="member.address1" label="기본주소" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details readonly @click="$refs.daumPostcode.open()" />
                                                </v-col>
                                                <v-col class="pa-1" cols="12" md="6">
                                                    <v-text-field v-model="member.address2" label="상세주소" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details />
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12">
                                    <v-row class="ma-n1">
                                        <v-col class="pa-1" cols="12" md="4">
                                            <v-select v-model="member.levelCode" :disabled="!$hasScope(['root', 'admin'])" :items="levels" item-text="name" item-value="code" label="회원등급" persistent-placeholder hide-details />
                                        </v-col>
                                        <v-col class="pa-1" cols="12" md="4">
                                            <v-select v-model="member.riskManagement.giftcard.level" :disabled="!$hasScope(['root', 'admin'])" :items="riskManagement.giftcard.levels" item-text="text" item-value="value" label="교환소등급" persistent-placeholder hide-details />
                                        </v-col>
                                        <v-col class="pa-1" cols="12" md="4">
                                            <autocomplete-viewer v-model="member._viewer" :disabled="!$hasScope(['root', 'admin'])" label="추천인" persistent-placeholder hide-details clearable />
                                        </v-col>
                                        <v-col class="pa-1" cols="12">
                                            <v-text-field v-model="member.ci" label="CI 값" :disabled="!$hasScope(['root', 'admin'])" persistent-placeholder hide-details />
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col class="pa-2" cols="12" md="4">
                    <v-row class="ma-n2">
                        <v-col class="pa-2" cols="12">
                            <v-card>
                                <v-card-title>
                                    <span class="subtitle-2">로그인 실패횟수 ({{ member.loginFailedCount[$dayjs().format("YYYY-MM-DD")] || 0 }}/5)</span>
                                    <v-spacer />
                                    <v-icon :disabled="!$hasScope(['root', 'admin'])" size="20" @click="member.loginFailedCount = new Map()">mdi-refresh</v-icon>
                                </v-card-title>
                            </v-card>
                        </v-col>
                        <v-col class="pa-2" cols="12">
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <v-card class="rounded-b-0">
                                        <v-card-title>
                                            <span class="subtitle-2">자동차단여부 (차단안함/차단)</span>
                                            <v-spacer />
                                            <v-switch v-model="member.isAutoBlock" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0" />
                                        </v-card-title>
                                    </v-card>
                                </v-col>
                                <v-col cols="12"> <v-divider /> </v-col>
                                <v-col cols="12">
                                    <v-card class="rounded-t-0">
                                        <v-card-title>
                                            <span class="subtitle-2">관리자차단여부 (차단안함/차단)</span>
                                            <v-spacer />
                                            <v-switch v-model="member.isBlock" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0" />
                                        </v-card-title>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col class="pa-2" cols="12">
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <v-card class="rounded-b-0">
                                        <v-card-title>
                                            <span class="subtitle-2">휴면여부 (휴면안함/휴면)</span>
                                            <v-spacer />
                                            <v-switch v-model="member.isDormancy" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0" />
                                        </v-card-title>
                                    </v-card>
                                </v-col>
                                <v-col cols="12"> <v-divider /> </v-col>
                                <v-col cols="12">
                                    <v-card class="rounded-t-0">
                                        <v-card-title>
                                            <span class="subtitle-2">관리자 생성 회원</span>
                                            <v-spacer />
                                            <v-switch v-model="member.isAdminCreated" disabled hide-details class="mt-0" />
                                        </v-card-title>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col class="pa-2" cols="12">
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <v-card class="rounded-b-0">
                                        <v-card-title>
                                            <span class="subtitle-2">SMS 수신여부 (수신안함/수신)</span>
                                            <v-spacer />
                                            <v-switch v-model="member.smsEnabled" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0" />
                                        </v-card-title>
                                    </v-card>
                                </v-col>
                                <v-col cols="12"> <v-divider /> </v-col>
                                <v-col cols="12">
                                    <v-card class="rounded-t-0">
                                        <v-card-title>
                                            <span class="subtitle-2">Email 수신여부 (수신안함/수신)</span>
                                            <v-spacer />
                                            <v-switch v-model="member.emailEnabled" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0" />
                                        </v-card-title>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col class="pa-2" cols="12">
                            <v-card>
                                <v-card-title>
                                    <span class="subtitle-2">API 사용 허용 (자동충전·조회)</span>
                                    <v-spacer />
                                    <v-switch v-model="member.isApiAllowed" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0" />
                                </v-card-title>
                                <v-card-subtitle class="pt-0 caption">
                                    <template v-if="member.isApiAllowed"> 이 계정의 아이디·비밀번호로 발급한 토큰으로 자동충전과 조회를 모두 사용할 수 있습니다 </template>
                                    <template v-else> 꺼두면 토큰 발급도, 이미 발급된 토큰의 사용도 모두 차단됩니다 </template>
                                </v-card-subtitle>
                            </v-card>
                        </v-col>
                        <v-col class="pa-2" cols="12">
                            <v-card>
                                <v-card-title>
                                    <span class="subtitle-2">선물 자동받기 (받지않음/자동받기)</span>
                                    <v-spacer />
                                    <v-switch v-model="member.isAutoTake" :disabled="!$hasScope(['root', 'admin'])" hide-details class="mt-0" />
                                </v-card-title>
                                <v-card-subtitle class="pt-0 caption">
                                    <template v-if="member.isAutoTake && member.autoTakeAt"> {{ $dayjs(member.autoTakeAt).format("YYYY-MM-DD HH:mm") }} 이후 도착한 선물이 자동으로 수령됩니다 </template>
                                    <template v-else-if="member.isAutoTake"> 저장하면 그 시점 이후 도착한 선물이 자동으로 수령됩니다 </template>
                                    <template v-else> 켜기 이전에 쌓여 있던 미수령 선물은 자동으로 받지 않습니다 </template>
                                </v-card-subtitle>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>

                <v-col class="pa-2" cols="12">
                    <v-card>
                        <v-card-title class="subtitle-2 font-weight-bold">관리자 메모</v-card-title>
                        <v-card-text>
                            <v-textarea v-model="member.note" :disabled="!$hasScope(['root', 'admin'])" outlined hide-details rows="2" />
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col class="pa-2" cols="12" v-if="!isCreate">
                    <purchase-list />
                </v-col>

                <v-col class="pa-2" cols="12">
                    <v-row no-gutters>
                        <v-spacer />
                        <v-col cols="auto">
                            <v-btn :disabled="!$hasScope(['root', 'admin'])" color="primary" @click="save">저장</v-btn>
                        </v-col>
                        <v-spacer />
                    </v-row>
                </v-col>
            </v-row>
        </console-body>

        <daum-postcode ref="daumPostcode" @input="({ postcode, address }) => (member = { ...member, postcode, address })" />

        <common-loader v-bind="{ loading }" />
    </console-layout>
</template>

<script>
import api from "@/api";
import { mdiRefresh } from "@mdi/js";
import CryptoAES from "@/plugins/crypto-aes";

import CommonLoader from "@/components/common/common-loader.vue";
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";
import PurchaseList from "@/components/console/user/purchase-list.vue";
import VPasswordField from "@/components/plugins/vuetify/v-password-field.vue";
import AutocompleteViewer from "@/components/console/dumb/autocompletes/autocomplete-viewer.vue";

function initMember(data) {
    return {
        ...data,
        _id: data?._id ?? null,
        isAutoTake: data?.isAutoTake ?? false,
        isApiAllowed: data?.isApiAllowed ?? false,
        riskManagement: {
            ...(data?.riskManagement || {}),
            giftcard: {
                ...(data?.riskManagement?.giftcard || {}),
            },
        },
        loginFailedCount: {
            ...(data?.loginFailedCount || {}),
        },
    };
}

export default {
    components: {
        CommonLoader,
        DaumPostcode,
        VPasswordField,
        PurchaseList,
        NaverSmarteditor,
        AutocompleteViewer,
    },
    props: {
        _member: { type: String, default: null },
    },
    data() {
        return {
            mdiRefresh,

            member: initMember({ _id: this._member }),

            levels: [],

            riskManagement: {
                giftcard: {
                    levels: [
                        { text: "일반등급", value: "normal" },
                        { text: "vip", value: "vip" },
                        { text: "vvip", value: "vvip" },
                    ],
                },
            },

            loading: false,
        };
    },
    computed: {
        isCreate() {
            return !this._member;
        },
    },
    methods: {
        async init() {
            if (!this.loading) this.loading = true;

            let _member = this._member;
            try {
                let { levels } = await api.console.member.levels.gets();
                this.levels = levels;

                if (_member !== this._member) return;

                if (this.isCreate) this.member = initMember({ isAdminCreated: true });
                else {
                    let { member } = await api.console.members.get({ _id: _member });
                    if (_member === this._member) this.member = member;
                }
            } finally {
                if (_member === this._member) this.loading = false;
            }
        },
        async save() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { password, ...form } = this.member;
                if (password) form.password = CryptoAES.encrypt(password);
                if (this.isCreate) form.isAdminCreated = true;

                const { post, put } = api.console.members;
                let { member } = await (this.isCreate ? post : put)(form);

                alert("저장되었습니다");
            } finally {
                this.loading = false;
            }
        },
    },
    mounted() {
        this.init();
    },
};
</script>
